import { render, staticRenderFns } from "./presentation-ppt-upload-section.vue?vue&type=template&id=203e9740&"
import script from "./presentation-ppt-upload-section.vue?vue&type=script&lang=js&"
export * from "./presentation-ppt-upload-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports